/**
 * @file How To Participate.
 */

/**
 * How To Participate functions.
 *
 * Runs js specific to the How To Participate template.
 */
const vHowToParticipate = () => {
	import('../../components/anchor-menu/anchor-menu').then((m) => m.default());
};

if (document.readyState !== 'loading') {
	vHowToParticipate();
} else {
	document.addEventListener('DOMContentLoaded', vHowToParticipate);
}
